export default "__VITE_ASSET__CCySwY9R__"